import {
  MONEY_NUM_FMT,
  PCT_NUM_FMT,
} from '../../../QuickCashflowModel/calc/excelTheme';
import { monitoringRoasCovenantScaledPct } from './monitoringHelpers';

export const MONITORING_MONEY_TWO_DECIMAL_NUM_FMT =
  '$#,##0.00;[Red]($#,##0.00)';
export const MONITORING_PCT_ONE_DECIMAL_NUM_FMT = '0.0%';
export const MONITORING_INTEGER_NUM_FMT = '#,##0';
export const MONITORING_DECIMAL_NUM_FMT = '0.0000';

export function finiteExportNumber(value) {
  if (value == null || value === '') {
    return null;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function monitoringCovenantKpiIsPercent(kpi) {
  return (
    kpi?.includes('%') || kpi?.toLowerCase().includes('mom increase')
  );
}

/**
 * Covenant KPI values: percent KPIs use the same /100 scale as the Monitoring UI table.
 */
export function monitoringCovenantValueForExcel(kpi, value) {
  const n = finiteExportNumber(value);
  if (n == null) {
    return null;
  }
  if (monitoringCovenantKpiIsPercent(kpi)) {
    return n / 100;
  }
  return n;
}

export function setExcelNumericCell(cell, value, numFmt) {
  const n = finiteExportNumber(value);
  if (n == null) {
    cell.value = null;
    return;
  }
  cell.value = n;
  if (numFmt) {
    cell.numFmt = numFmt;
  }
}

export function setExcelMoneyCell(cell, value, { decimals = 0 } = {}) {
  const fmt =
    decimals === 2
      ? MONITORING_MONEY_TWO_DECIMAL_NUM_FMT
      : MONEY_NUM_FMT;
  setExcelNumericCell(cell, value, fmt);
}

/** Decimal fraction (0.62 → 62%). */
export function setExcelPercentFractionCell(
  cell,
  value,
  numFmt = MONITORING_PCT_ONE_DECIMAL_NUM_FMT,
) {
  setExcelNumericCell(cell, value, numFmt);
}

/** Percentage points (60 → 60%). */
export function setExcelPercentPointsCell(
  cell,
  value,
  numFmt = MONITORING_PCT_ONE_DECIMAL_NUM_FMT,
) {
  const n = finiteExportNumber(value);
  if (n == null) {
    cell.value = null;
    return;
  }
  cell.value = n / 100;
  cell.numFmt = numFmt;
}

export function monitoringRoasPctForExcel(cell, view, covenantMultiplier = 1) {
  return finiteExportNumber(
    monitoringRoasCovenantScaledPct(cell, view, covenantMultiplier),
  );
}

export function writeMonitoringCovenantValueCell(cell, kpi, value) {
  const excelValue = monitoringCovenantValueForExcel(kpi, value);
  if (excelValue == null) {
    cell.value = null;
    return;
  }
  if (monitoringCovenantKpiIsPercent(kpi)) {
    setExcelPercentFractionCell(cell, excelValue, PCT_NUM_FMT);
  } else {
    setExcelMoneyCell(cell, excelValue);
  }
}
